module.exports = __webpack_public_path__ + "static/media/img_shiyan@2x.dc024df2.png";